import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBurgerMenu = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 20,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.75 13.5h18.5a.75.75 0 0 0 0-1.5H.75a.75.75 0 0 0 0 1.5Zm0-6h18.5a.75.75 0 0 0 0-1.5H.75a.75.75 0 0 0 0 1.5ZM0 .75c0 .414.336.75.75.75h18.5a.75.75 0 0 0 0-1.5H.75A.75.75 0 0 0 0 .75Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgBurgerMenu;